"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Set text color or background color to the given element
 * @param element The element to set color to
 * @param color The color to set, it can be a string of color name/value or a ModeIndependentColor object
 * @param isBackgroundColor Whether set background color or text color
 * @param isDarkMode Whether current mode is dark mode. @default false
 */
function setColor(element, color, isBackgroundColor, isDarkMode) {
    var colorString = typeof color === 'string' ? color.trim() : '';
    var modeIndependentColor = typeof color === 'string' ? null : color;
    if (colorString || modeIndependentColor) {
        element.style.setProperty(isBackgroundColor ? 'background-color' : 'color', (isDarkMode
            ? modeIndependentColor === null || modeIndependentColor === void 0 ? void 0 : modeIndependentColor.darkModeColor : modeIndependentColor === null || modeIndependentColor === void 0 ? void 0 : modeIndependentColor.lightModeColor) || colorString);
        if (element.dataset) {
            var dataSetName = isBackgroundColor
                ? "ogsb" /* OriginalStyleBackgroundColor */
                : "ogsc" /* OriginalStyleColor */;
            if (!isDarkMode) {
                delete element.dataset[dataSetName];
            }
            else if (modeIndependentColor) {
                element.dataset[dataSetName] = modeIndependentColor.lightModeColor;
            }
        }
    }
}
exports.default = setColor;
//# sourceMappingURL=setColor.js.map